import { useCallback, useEffect, useState } from 'react'

import { fetchPosQuickKeys } from '@/lib/api/posQuickKeys'

/**
 * @param {object} [options]
 * @param {number | null} [options.branchId]
 * @param {boolean} [options.enabled]
 */
export function usePosQuickKeys({ branchId, enabled = true } = {}) {
  const [quickKeys, setQuickKeys] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const reload = useCallback(async () => {
    if (!enabled || !branchId) {
      setQuickKeys([])
      setLoading(false)
      return []
    }

    setLoading(true)
    setError('')
    try {
      const items = await fetchPosQuickKeys()
      setQuickKeys(items)
      return items
    } catch (err) {
      setQuickKeys([])
      setError(err?.response?.data?.message ?? 'Unable to load quick keys.')
      return []
    } finally {
      setLoading(false)
    }
  }, [branchId, enabled])

  useEffect(() => {
    reload()
  }, [reload])

  return {
    quickKeys,
    loading,
    error,
    reload,
  }
}
